<template>
    <p class="loan-repayment-amount">
        <span :class="['main-text', largeMobileValue ? 'large-main-text' : 'small-main-text']">
            {{ $t('results.loanTermRange', { termDisplay: offer.term_display }) }}
        </span>

        <span class="small-text d-flex align-self-start">
            {{ loanTermLabel }}
        </span>
    </p>
</template>

<script>
export default {
    props: {
        largeMobileValue: {
            type: Boolean,
            default: true,
        },
    },
    inject: ['offer'],
    computed: {
        loanTermLabel: function () {
            if (this.includeTerritories('usa') && this.offer.type === 'debt_solution') {
                return 'Term'
            }
            return this.$t('results.loanTermRangeLabel')
        },
    },
}
</script>
